import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'ngx-next-button',
    template: `<nb-icon icon="arrow-forward-outline"></nb-icon>`,
})
export class NextButtonComponent {}
